module.exports = __webpack_public_path__ + "fb74a137a113bf612d8369d3fda63da2.png";